export const GROUP_STATUS_ACTIVE = 'active';
export const GROUP_STATUS_DRAFT = 'draft';
export const GROUP_STATUS_SUSPENDED = 'suspended';
export const GROUP_STATUS_CLOSED = 'closed';

export type GroupStatus =
    | typeof GROUP_STATUS_ACTIVE
    | typeof GROUP_STATUS_DRAFT
    | typeof GROUP_STATUS_SUSPENDED
    | typeof GROUP_STATUS_CLOSED;

export const GROUP_STATUSES_SENDING: GroupStatus[] = [GROUP_STATUS_ACTIVE];
export const GROUP_STATUSES_HUB: GroupStatus[] = [GROUP_STATUS_ACTIVE, GROUP_STATUS_DRAFT];
export const GROUP_STATUSES_MANAGEMENT: GroupStatus[] = [GROUP_STATUS_ACTIVE, GROUP_STATUS_DRAFT];
export const GROUP_STATUSES_CONFIGURABLE: GroupStatus[] = [
    GROUP_STATUS_ACTIVE,
    GROUP_STATUS_DRAFT,
    GROUP_STATUS_SUSPENDED,
];

export const GROUP_STATUS_ALLOWED_TRANSITIONS: Record<GroupStatus, GroupStatus[]> = {
    [GROUP_STATUS_DRAFT]: [GROUP_STATUS_ACTIVE, GROUP_STATUS_CLOSED],
    [GROUP_STATUS_ACTIVE]: [GROUP_STATUS_SUSPENDED, GROUP_STATUS_CLOSED],
    [GROUP_STATUS_SUSPENDED]: [GROUP_STATUS_ACTIVE, GROUP_STATUS_CLOSED],
    [GROUP_STATUS_CLOSED]: [],
};
